import { useFeatureFlag, useFeatureFlagStatus } from './useFeatureFlag'

/** Feature-flag name for the unified "Zu Produkt hinzufügen" overlay. */
export const UNIFIED_ADD_TO_PRODUCT_FLAG = 'unified_add_to_product_overlay'

/**
 * Returns whether the unified Add-to-Product overlay is enabled for the
 * current workspace. Thin wrapper over the real {@link useFeatureFlag} hook;
 * defaults to `false` while loading or when the flag is disabled/unknown.
 */
export function useUnifiedAddToProductFlag(): boolean {
  return useFeatureFlag(UNIFIED_ADD_TO_PRODUCT_FLAG)
}

/**
 * Status-aware variant of {@link useUnifiedAddToProductFlag}. Returns
 * `isPending` so a consumer can defer rendering until the flag resolves —
 * avoids flashing the legacy fallback before the (rolled-out) flag turns on.
 */
export function useUnifiedAddToProductFlagStatus(): {
  enabled: boolean
  isPending: boolean
} {
  return useFeatureFlagStatus(UNIFIED_ADD_TO_PRODUCT_FLAG)
}
